import React from "react";

/**
 * Reusable NumberInput component for numeric inputs with validation
 */
const NumberInput = ({
  label,
  value,
  min,
  max,
  onChange,
  onBlur,
  onKeyDown,
  style = {},
  labelStyle = {},
}) => {
  const inputStyle = {
    width: "100%",
    padding: "4px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    background: "#fff",
    ...style,
  };

  const defaultLabelStyle = {
    width: "50px",
    whiteSpace: "nowrap",
    ...labelStyle,
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flex: 1,
      }}
    >
      {label && <label style={defaultLabelStyle}>{label}</label>}
      <input
        type="number"
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        style={inputStyle}
      />
    </div>
  );
};

export default NumberInput;
